import { EditMode } from "./state/uiState";
const configurationFull = {
    startEditMode: EditMode.NEUTRAL,
    debug: false,
    showMenu: true,
    menuItems: {
        showNewAutomaton: true,
        showSaveAutomaton: true,
        showLoadAutomaton: true,
        showScreenshot: true,
    },
    showResetSimulationButton: false,
    startup: {
        showNewAutomatonDialog: true,
    }
};
const configurationEdit = {
    startEditMode: EditMode.NEUTRAL,
    debug: false,
    showMenu: true,
    menuItems: {
        showNewAutomaton: false,
        showSaveAutomaton: true,
        showLoadAutomaton: true,
        showScreenshot: false,
    },
    showResetSimulationButton: false,
    startup: {
        showNewAutomatonDialog: false,
    }
};
const configurationSimulation = {
    startEditMode: EditMode.EXECUTION,
    debug: false,
    showMenu: false,
    menuItems: {
        // die folgenden Einträge spielen keine Rolle,
        // da das Menü ohnehin nicht angezeigt wird
        showNewAutomaton: false,
        showSaveAutomaton: false,
        showLoadAutomaton: false,
        showScreenshot: false,
    },
    showResetSimulationButton: true,
    startup: {
        showNewAutomatonDialog: false,
    }
};
export const configurations = {
    full: configurationFull,
    edit: configurationEdit,
    simulation: configurationSimulation,
};
